import raf            from 'raf';
import helperA11y     from 'shared/mixins/helper-a11y';

/**
 * a really simple tabstrip implementation working by
 * events triggered in the tabstrip function.
 */
function tabstrip(el, app) {

    const a11yHelper                = helperA11y(app);

    const $el = $(el);
    const $tabs     = $el.find('.Ge-Tabstrip-Tab');
    const $contents = $el.find('.Ge-Tabstrip-Content');

    const init = function() {
        registerEvents();
        // notify other methods that the tabstrip is ready
        raf(function tick1() {
            raf(function tick2() {
                app.trigger('tabstripReady',[$el]);
                $el.addClass('Ge-Tabstrip--ready');
            });
        });
    };

    const registerEvents = function() {
        $tabs.click(function(ev) {
            ev.preventDefault();
            const tab = this.getAttribute('id');
            const panel = this.getAttribute('aria-controls');
            $el.trigger('tab:activated', [tab, panel]);
        });
        $tabs.keyup(function(ev) {
            if(ev && ev.keyCode == 13){
                const tab = this.getAttribute('id');
                const panel = this.getAttribute('aria-controls');
                $el.trigger('tab:activated', [tab, panel]);
                $(tab).removeClass('focus-visible');
            }
        });
        $el.on('tab:activated', toggle);
    };

    const toggle = function(ev, tab, panel) {
        toggleTab(ev, tab, panel);
        toggleContent(ev, tab, panel);
    };

    const toggleTab = function(ev, tab, panel) {

        const $tab = $tabs.filter('#' + tab);
        $tab.siblings('.Ge-Tabstrip-Tab').attr('aria-selected',false).removeClass('Ge-Tabstrip-Tab--Active');
        $tab.attr('aria-selected',true).addClass('Ge-Tabstrip-Tab--Active');

    };

    const toggleContent = function(ev, tab, panel) {

        // hide all aria and hidden fields of the old active tab
        const $oldPanel = $contents.filter('Ge-Tabstrip-Content--Active');
        a11yHelper.hide($oldPanel);

        const $newPanel = $contents.filter('#' + panel);
        $newPanel.siblings('.Ge-Tabstrip-Content').attr('aria-hidden',true).removeClass('Ge-Tabstrip-Content--Active');
        $newPanel.attr('aria-hidden',false).addClass('Ge-Tabstrip-Content--Active');

        raf(function tick1() {
            raf(function tick2() {
                // show all aria and hidden fields of the new active tab
                a11yHelper.show($newPanel);
            });
        });
    };

    return {
        init: init()
    };
}

tabstrip.selector = '[data-js-tabstrip]';
export default tabstrip;
